// extracted by mini-css-extract-plugin
export default {"btnPrimary":"buttons_btnPrimary__mZu3E","btnSecondary":"buttons_btnSecondary__Kz5LM"};